import moment from 'moment';

export default class filter{
    constructor(){

    }
    myDate(created){
        return moment(created).lang(window.langKey).format('LL');
    }
    yesno(value){
        if(value){
            return '<i class="fas fa-check green"></i>';
        }
        return '<i class="fas fa-times red"></i>'
    }
    llDateAndTime(timestamp){
//        return moment(timestamp).format('LLL');
        return moment(timestamp).format('DD.MM.YYYY HH:mm');
    }
    formatNumber(total){
        let num = parseFloat(total);
        let m = Number((Math.abs(num) * 100).toPrecision(15));
        let formattedTotal = Math.round(m) / 100 * Math.sign(num);
        
        let options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          };
        return new Intl.NumberFormat(window.locale,options).format(formattedTotal);
    }
    r(data){
        if(typeof data ==='string'){
            return window.i18n.global.t(data);
        }
        if(data.messageData){
            return window.i18n.global.t(data.message, [data.messageData]);
        }
        return window.i18n.$t(data.message);
    }
}